import React from 'react';
import Switch from 'react-switch';

import { ThemeProps, withTheme } from 'styled-components';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Filter, FilterIcon } from './styles';

interface Props extends ThemeProps<any> {
  hasDirectFlights: boolean;
  directFlights: boolean;
  onFilterDirectFlights: () => void;
  onFilterClick: () => void;
  airSearchFilterDirectFlight: boolean;
}

const FloatingFilter = ({
  hasDirectFlights,
  directFlights,
  theme,
  onFilterDirectFlights,
  onFilterClick,
  airSearchFilterDirectFlight,
}: Props) => {
  const { t } = useStoreTranslation();

  return (
    <Container>
      <Filter>
        {hasDirectFlights && !airSearchFilterDirectFlight && (
          <>
            <div onClick={onFilterDirectFlights} data-testid="flight-list-filter-direct">
              <Switch
                width={22}
                height={15}
                checkedIcon={false}
                uncheckedIcon={false}
                checked={directFlights}
                onChange={onFilterDirectFlights}
                offColor={theme.flightsList.filterSwitchOffColor}
                onColor={theme.flightsList.filterSwitchOnColor}
              />
              <Filter.Label className={directFlights ? 'active' : ''}>{t('flightsList.direct')}</Filter.Label>
            </div>
            <Filter.Divider />
          </>
        )}
        <div onClick={onFilterClick} data-testid="flight-list-filter-button">
          <FilterIcon />
          <Filter.Label>{t('flightsList.filter')}</Filter.Label>
        </div>
      </Filter>
    </Container>
  );
};

export default withTheme(FloatingFilter);
